import type { Publication } from './publications';

export const renanQuijanoPublications: Publication[] = [
  {
    id: 'renan-004',
    title: 'Potential of a low-cost system for measuring indoor environmental quality in Latin American extreme climates towards energy equity (Potencial de un sistema de bajo costo para medir la calidad ambiental interior en climas extremos latinoamericanos hacia la equidad energética)',
    authors: 'Claudia Eréndira Vázquez-Torres, Renán Gabriel Quijano-Cetina, Israel Sánchez-Domínguez, Ali Bassam',
    date: '2024-12-01',
    type: 'article',
    venue: 'Revista Hábitat Sustentable, vol. 14, no. 2, pp. 76–85',
    doi: 'https://doi.org/10.22320/07190700.2024.14.02.06',
    abstract: 'Sistema de sensores de bajo costo para medir contaminantes en interiores, calibrado y validado en un clima cálido extremo del sur de México según normas nacionales e internacionales. Demuestra su viabilidad (57% de las lecturas de H2S superaron 150 ppm) y se publica en acceso abierto para investigadores con pocos recursos.',
    tags: [
      'environmental measurement system',
      'low-cost sensors',
      'indoor environmental quality',
      'pollutant measurement',
    ],
    pdfUrl: 'https://revistas.ubiobio.cl/index.php/RHS/article/download/6678/5032/59466',
  },
  {
    id: 'renan-006',
    title: 'Prototipado rápido para monitoreo IoT a través de Bluetooth y aplicaciones móviles (Fast prototyping for IoT monitoring through Bluetooth and mobile applications)',
    authors: 'José Agustín Hernández-Benítez, José R. Atoche-Enseñat, Ricardo Javier Peón-Escalante, et al., Jorge Carlos Canto-Esquivel',
    date: '2022-12-01',
    type: 'article',
    venue: 'Ingeniería — Revista Académica de la Facultad de Ingeniería, UADY',
    publicAccessUrl: 'https://www.revista.ingenieria.uady.mx/ojs/index.php/ingenieria/article/view/345',
    pdfUrl: 'https://www.revista.ingenieria.uady.mx/ojs/index.php/ingenieria/article/download/345/241',
  },
  {
    id: 'renan-008',
    title: 'Energy Metering Integrated Circuit Behavior beyond Standards Requirements',
    authors: 'Renán Quijano-Cetina, Yljon Seferi, Steven M. Blair, Paul S. Wright',
    date: '2021-01-12',
    type: 'article',
    venue: 'Energies (MDPI), vol. 14, no. 2, art. 390',
    doi: 'https://doi.org/10.3390/en14020390',
    abstract: 'Prueba un circuito integrado de medición de energía con señales distorsionadas de normas, corrientes reales registradas y formas de onda con cambios rápidos típicos de electrónica de potencia. Encuentra un límite de exactitud ligado al fenómeno de Gibbs, con error dependiente de la pendiente de la señal y el ángulo de fase, y propone un método de evaluación de medidores.',
    publicAccessUrl: 'https://www.mdpi.com/1996-1073/14/2/390',
    pdfUrl: 'https://strathprints.strath.ac.uk/75024/1/Quijano_Cetina_etal_Energies_2021_Energy_metering_integrated_circuit_behavior.pdf',
  },
  {
    id: 'renan-009',
    title: 'Sistema de monitoreo inalámbrico de bajo costo para módulos fotovoltaicos empleando Raspberry Pi',
    authors: 'Óscar May-Tzuc, Renán Quijano-Cetina, Juliana Anahí González-Quijano, José Daniel Ortiz-López',
    date: '2016-10-01',
    type: 'article',
  },
  {
    id: 'renan-013',
    title: 'Social energy demand: Environmental Quality in Mayan Indigenous Communities from Mexico',
    authors: 'Claudia Eréndira Vázquez-Torres, Leticia Ozawa-Meida, Renán Quijano-Cetina, Marcos Eduardo González-Trevizo',
    date: '2025-06-01',
    type: 'conference-paper',
  },
  {
    id: 'renan-014',
    title: 'Review of PMU Algorithms Suitable for Real-Time Operation With Digital Sampled Value Data',
    authors: 'Yljon Seferi, Renán Quijano-Cetina, Steven M. Blair',
    date: '2021-09-29',
    type: 'conference-paper',
    venue: '2021 IEEE 11th International Workshop on Applied Measurements for Power Systems (AMPS), virtual',
    abstract: 'Revisa algoritmos de Unidades de Medición Fasorial (PMU) compatibles con datos Sampled Values IEC 61850-9-2. El procesamiento remoto añade latencia, por lo que pocos algoritmos cumplen IEC/IEEE 60255-118-1 estimando sincrofasores, frecuencia y ROCOF muestra a muestra; se dan pautas de selección.',
    publicAccessUrl: 'https://strathprints.strath.ac.uk/78316',
    pdfUrl: 'https://strathprints.strath.ac.uk/78316/1/Seferi_etal_WAMPS_2021_Review_of_PMU_algorithms_suitable_for_real_time_operation.pdf',
  },
  {
    id: 'renan-015',
    title: 'Analysis and Selection of Appropriate Components for Power System Metrology Instruments',
    authors: 'Renán Quijano-Cetina, Yljon Seferi, Steven M. Blair, Paul S. Wright',
    date: '2019-03-09',
    type: 'conference-paper',
    venue: '2019 2nd International Colloquium on Smart Grid Metrology (SMAGRIMET), IEEE',
    doi: 'https://doi.org/10.23919/SMAGRIMET.2019.8720362',
    abstract: 'Revisa componentes de hardware y técnicas de procesamiento comunes en instrumentos de metrología de sistemas eléctricos, mostrando cómo cada etapa de la cadena de señal afecta la exactitud final. Ofrece guía práctica para diseñar medidores de energía y PMU.',
    pdfUrl: 'https://strathprints.strath.ac.uk/67315/1/Quijano_Cetina_etal_ICSGM_2019_Analysis_and_selection_of_appropriate_components_for_power_system_metrology_instruments.pdf',
  },
  {
    id: 'renan-017',
    title: 'Challenges for Smart Electricity Meters due to Dynamic Power Quality Conditions of the Grid: A Review',
    authors: 'Renán Quijano-Cetina, Andrew J. Roscoe, Paul S. Wright',
    date: '2017-09-20',
    type: 'conference-paper',
    venue: '2017 IEEE International Workshop on Applied Measurements for Power Systems (AMPS)',
    doi: 'https://doi.org/10.1109/AMPS.2017.8078345',
    abstract: 'Revisión de los retos actuales y futuros de los medidores inteligentes ante la calidad de energía dinámica de la red (renovables, cargas no lineales, carga de vehículos eléctricos). Señala que el límite normativo de 3% de distorsión no refleja muchas condiciones reales.',
    pdfUrl: 'https://strathprints.strath.ac.uk/61521/1/Cetina_etal_AMPS_2017_Challenges_for_smart_electricity_meters_due_to_dynamic_power_quality_conditions_of_the_grid.pdf',
  },
  {
    id: 'renan-018',
    title: 'A review of electrical metering accuracy standards in the context of dynamic power quality conditions of the grid',
    authors: 'Renán Quijano-Cetina, Andrew J. Roscoe, Paul S. Wright',
    date: '2017-08-29',
    type: 'conference-paper',
    venue: '52nd International Universities Power Engineering Conference (UPEC 2017), IEEE',
    doi: 'https://doi.org/10.1109/UPEC.2017.8231871',
    abstract: 'Analiza las normas de exactitud de medidores eléctricos frente a formas de onda distorsionadas: no existe un procedimiento de calibración estandarizado y normas como EN 50470-3 admiten errores de hasta ±2.5%. Propone incluir pruebas con distorsión y requisitos más estrictos en medidores de facturación.',
    pdfUrl: 'https://strathprints.strath.ac.uk/61571/1/Quijano_Cetina_etal_IUPEC_2017_A_review_of_electrical_metering_accuracy_standards_in_the_context_of_dynamic_power_quality.pdf',
  },
  {
    id: 'renan-020',
    title: 'Generador de Campo Magnético Variable',
    date: '2013-10-01',
    type: 'conference-paper',
  },
  {
    id: 'renan-022',
    title: 'Thermal Efficiency Prediction of a Solar Low Enthalpy Steam Generating Plant Employing Artificial Neural Networks',
    authors: 'Óscar May-Tzuc, Ali Bassam, Manuel Flota-Bañuelos, E. E. Ordóñez-López, Lifter Ricalde-Cab, Renán Quijano-Cetina, et al., Alan Vega-Pasos',
    date: '2016-03-01',
    type: 'chapter',
    venue: 'Intelligent Computing Systems — ISICS 2016, Mérida (A. Martin-Gonzalez, V. Uc-Cetina, eds.), Communications in Computer and Information Science, vol. 597, Springer, pp. 61–73',
  },
  {
    id: 'renan-023',
    title: 'Sistema domótico de control de luces mediante una aplicación Android basado en una tarjeta Raspberry-Pi',
    authors: 'Óscar May-Tzuc, Renán Quijano-Cetina, Fernando Fernández',
    date: '2015-05-01',
    type: 'chapter',
  },
  {
    id: 'renan-024',
    title: 'Indoor Environmental Quality database for a low-income housing in Merida, Yucatan, Mexico',
    authors: 'Claudia Eréndira Vázquez-Torres, Renán Gabriel Quijano-Cetina, Israel Sánchez-Domínguez, Ali Bassam',
    date: '2024-08-16',
    type: 'dataset',
    venue: 'Mendeley Data, v1 (CC BY 4.0)',
    doi: 'https://doi.org/10.17632/y3s8fvv59k.1',
    abstract: 'Datos horarios de un año (jul 2023–jul 2024) de una vivienda social en Mérida: temperatura, presión, humedad, PM1.0/2.5/10, CO2, H2S y ruido (7,406 registros por variable), obtenidos con un prototipo de sensores de bajo costo calibrado.',
    tags: [
      'Change in Climate Extremes',
      'Indoor Air Pollution',
      'Spatial Environmental Quality',
    ],
    publicAccessUrl: 'https://data.mendeley.com/datasets/y3s8fvv59k',
  },
  {
    id: 'renan-025',
    title: 'Recommendations for static electricity meters beyond standards requirements',
    authors: 'Renán Gabriel Quijano-Cetina',
    date: '2022-05-30',
    type: 'thesis-doctoral',
    venue: 'Electronic and Electrical Engineering, University of Strathclyde',
    abstract: 'Desarrolla un método de prueba con formas de onda de cambios rápidos que expone límites de los circuitos internos de los chips de medición, analiza el efecto del factor de cresta y del factor de potencia en el error y propone un método de compensación, para orientar futuras normas de medidores estáticos.',
    publicAccessUrl: 'https://pureportal.strath.ac.uk/en/studentTheses/recommendations-for-static-electricity-meters-beyond-standards-re/',
  },
];
